import { getImageFromDB } from "../../../utils/indexedDB";
import { fnUrl } from "../../../config/endpoints";

export const labelRestorationUpdate = async ({
  canvasRef,
  token,
  uploadedImageId,
  resultImageId,
  petName,
  labelTemplate,
  orderId,
  image
}) => {
  const errors = [];

  if (!orderId) errors.push("Missing order ID.");
  if (!canvasRef?.current) errors.push("Canvas is not available.");
  if (!resultImageId) errors.push("Missing result image ID.");
  if (!uploadedImageId) errors.push("Missing uploaded image ID.");

  if (errors.length) {
    return { success: false, error: errors };
  }

  // Create canvas blob for the result image
  const resultBlob = await new Promise((resolve) => {
    canvasRef.current.toBlob((blob) => resolve(blob), "image/png");
  });

  if (!resultBlob) {
    return { success: false, error: ["Failed to create label image from canvas."] };
  }

  // Load uploaded image from IndexedDB
  const uploadedBlob = await getImageFromDB("uploadedImages", uploadedImageId);
  if (!uploadedBlob) {
    return { success: false, error: ["Uploaded image not found in IndexedDB."] };
  }

  // Compose attachments
  const resultFile = new File([resultBlob], `${resultImageId}.png`, { type: "image/png" });
  const originalFile = new File([uploadedBlob], `${uploadedImageId}.png`, { type: "image/png" });

  const imageMetadata = {
    x: parseFloat(image.x.toFixed(1)),
    y: parseFloat(image.y.toFixed(1)),
    scale: image.scale,
    width: image.width,
    height: image.height,
    maxScale: image.maxScale,
    rotation: image.rotation,
  };

  const jsonPayload = {
    order_id: orderId,
    token: token,
    file_custom_label: resultImageId,
    file_original_photos: [uploadedImageId],
    pet_name: petName,
    label_template: labelTemplate,
    image_metadata: JSON.stringify(imageMetadata),
    attachments: [
      { slug: resultImageId, file: `ATTACHMENT_${resultImageId}` },
      { slug: uploadedImageId, file: `ATTACHMENT_${uploadedImageId}` }
    ]
  };

  // Compose FormData
  const formData = new FormData();
  formData.append("payload", new Blob([JSON.stringify(jsonPayload)], { type: "application/json" }));
  formData.append(`ATTACHMENT_${resultImageId}`, resultFile);
  formData.append(`ATTACHMENT_${uploadedImageId}`, originalFile);

  // Submit to backend
  const response = await fetch(fnUrl("update-label"), {
    method: "POST",
    body: formData
  });

  const result = await response.json();

  if (!response.ok) {
    return {
      success: false,
      error: [result?.error || "Something went wrong while updating the label."],
      response: result
    };
  }

  return { success: true, response: result };
};
